const KEY = 'notify_cities_subscriptions';

export function loadSubscriptions() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveSubscriptions(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {}
}

export function loadCityConfig() {
  try {
    const raw = localStorage.getItem('notify_cities_custom_config');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveCityConfig(config) {
  try {
    localStorage.setItem('notify_cities_custom_config', JSON.stringify(config));
  } catch {}
}
